<template>
    <div class="person-blocks">
        <div class="row">
            <div class="col-md-12">
                <p class="text-center">
                    {{questionLabel}}
                    <span class="required-star" v-if="+question.field_required">*</span>
                    <i v-if="question.info.length" class="fa fa-info-circle fa-lg" data-toggle="tooltip"
                       data-placement="top" :title="question.info"></i>
                </p>
            </div>
        </div>

        <div class="row person-block-holder">
            <div class="block" v-for="questionType in questionTypes.slice(0, 2)"
                 :key="questionType.id">
                <div class="col-3">
                    <div v-bind:class="getBlockClass(questionType, answer)"
                         v-on:click="onCharacterClick(questionType.name)"></div>
                </div>
                <p>{{questionType.name}}</p>
            </div>
        </div>

        <div class="row person-block-holder">
            <div class="block" v-for="questionType in questionTypes.slice(2, 4)" :key="questionType.id">
                <div class="col-3">
                    <div v-bind:class="getBlockClass(questionType, answer)"
                         v-on:click="onCharacterClick(questionType.name)"></div>
                </div>
                <p>{{questionType.name}}</p>
            </div>
        </div>

        <div class="row error-row" v-if="hasError">
            <div class="col-md-12 text-center">
                Kies een karakter
            </div>
        </div>
    </div>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    name: 'CharacterField',

    props: ['question', 'hasError', 'answer', 'questionLabel'],

    methods: {
      onCharacterClick (value) {
        this.answer.value = value
      },
      getBlockClass: function (questionType, answer) {
        let className = 'image wrapblc' + questionType.id
        if (answer.value === questionType.name) {
          className += ' active'
        }
        return className
      }
    },
    computed: {
      ...mapGetters({
        questionTypes: 'question/getQuestionTypes',
      }),
    },
    mounted () {
      let answer = this.$store.getters['question/getAnswerByQuestionId'](this.question.id)
      if (typeof answer !== 'undefined') {
        this.answer = answer
      }
    }
  }
</script>

<style lang="scss" scoped>
    .error-row {
        color: red;
    }

    .wrap-block7 {
        margin-top: 50px;
        padding: 0 40px 0 40px;
    }

    .wrapblc1 {
        background-image: url(../../../assets/img/analytisch.png);
        background-position: center;
        background-size: cover;
    }

    .wrapblc2 {
        background-image: url(../../../assets/img/communicatief.png);
        background-size: cover;
        background-position: center;
    }

    .wrapblc3 {
        margin-top: 20px;
        background-image: url(../../../assets/img/georganiseerd.png);
        background-size: cover;
        background-position: center;
    }

    .wrapblc4 {
        margin-top: 20px;
        background-image: url(../../../assets/img/creatief.png);
        background-size: cover;
        background-position: center;
    }
</style>
